import { handleOdourContainerDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const gethandleOdourContainerEn = () => {
  const data = handleOdourContainerDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addhandleOdourContainer = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-should-i-handle-odors-coming-from-my-conainer`,
    ) &&
    document.getElementById(`handleOdourContainerJSONLD`) === null
  ) {
    const script = handleOdourContainerJSONLDEn()
    addJSONLDToHead(script, `handleOdourContainerJSONLD`)
  } else {
    removeElement(`handleOdourContainerJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const handleOdourContainerJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: gethandleOdourContainerEn(),
  }
  return FaqBagsterTemplate
}
